import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import CompanyProfile from './Components/CompanyProfile';
import Auction from './Components/admin/Auction';
import Login from './Components/admin/Login';
import Register from './Components/admin/Register';
import AdminPanel from "./Components/admin/AdminPanel";
import AddVehicle from "./Components/admin/AddVehicle";
import Vehicles from "./Components/admin/Vehicles";
import ViewUser from "./Components/admin/ViewUser";
import CreateAccount from "./Components/admin/CreateAccount";
import ViewSales from "./Components/admin/ViewSales";
import AddSale from "./Components/admin/AddSale";
import DocsShip from "./Components/admin/DocsShip";
import ViewVolet from "./Components/admin/ViewVolet";
import CreateVolet from "./Components/admin/CreateVolet";
import AllocatedPayments from "./Components/admin/AllocatedPayments";
import CreateAllocate from "./Components/admin/CreateAllocate";
import Accounts from "./Components/admin/Accounts";
import Portfolio from "./Components/admin/Portfolio";
import EditVehicles from "./Components/admin/EditVehicles";
import VehicleDetails from "./Components/VehicleDetails";
import SearchIndividual from "./Components/SearchIndividual";
import MiddleBanner from "./Components/MiddleBanner";
import TestMiddleBanner from "./Components/TestMiddleBanner";
import Footer from "./Components/Footer";
import SearchVehicle from "./Components/SearchVehicle";
import SearchResult from "./Components/SearchResult";
import Inventory from "./Components/Inventory";
import DealerInventory from "./Components/DealerInventory";
import SoldInventory from "./Components/SoldInventory";
import BankDetails from "./Components/BankDetails";
import HowToBuy from "./Components/HowToBuy";
import CustomerReview from "./Components/CustomerReview";
import Contact from "./Components/Contact";
import FAQ from "./Components/FAQ";
import CreateGroup from './Components/admin/CreateGroup';  // Changed to uppercase 'Components'
import ViewGroups from './Components/admin/ViewGroups';    // Changed to uppercase 'Components'
import Bids from './Components/admin/Bids';
import Leads from './Components/admin/Leads';
import Client from './Components/admin/Client';
import Stock from './Components/admin/Stock';
import SaleOrder from './Components/admin/SaleOrder';
import Invoice from './Components/admin/Invoice';
import AdminChatViewer from './Components/admin/AdminChatViewer';
import TawkToManager from './TawkToManager';
import ChatWidget from './Components/admin/ChatWidget';
import Announcements from './Components/admin/Announcements';
import NewAnnouncements from './Components/admin/NewAnnouncements';
import Transactions from './Components/admin/Transactions';
import TransactionsReport from './Components/admin/TransactionsReport';
import TransferReport from './Components/admin/TransferReport';
import BalanceSheet from './Components/admin/BalanceSheet';
import BankCash from './Components/admin/BankCash';

// Admin routes where Navbar and Footer should be hidden
const isAdminRoute = (pathname) => {
  const adminPaths = [
    '/admin-panel',
    '/add-vehicle',
    '/vehicles',
    '/view-user',
    '/create-account',
    '/view-sales',
    '/add-new-sale',
    '/documents-shipping',
    '/volet',
    '/create-volet',
    '/view-payments',
    '/create-allocate',
    '/accounts',
    '/portfolio',
    '/edit-vehicle',
    '/auction', // If auction is also an admin route
    '/create-group',
    '/view-groups',
    '/view-bids',
    '/view-leads',
    '/view-client',
    '/view-stock',
    '/view-sale-order',
    '/view-invoice',
    '/view-chat-admin',
    '/announcements',
    '/announcements/new',
    '/client-report/transactions',
    '/client-report/transactions-report',
    '/client-report/transfer-report',
    '/client-report/balance-sheet',
    '/client-report/bank-cash',
  ];
  
  return adminPaths.some(path => pathname.startsWith(path));
};

function App() {
  return (
    <Router>
      <TawkToManager />
      <ChatWidget />
      <Routes>
        {/* Public Routes with Navbar and Footer */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about-us/company-profile" element={<Layout><CompanyProfile /></Layout>} />
        <Route path="/sign-in" element={<Layout><Login /></Layout>} />
        <Route path="/sign-up" element={<Layout><Register /></Layout>} />
        <Route path="/search-individual" element={<Layout><SearchIndividual /></Layout>} />
        <Route path="/middle-banner" element={<Layout><MiddleBanner /></Layout>} />
        <Route path="/test-middle-banner" element={<Layout><TestMiddleBanner /></Layout>} />
        <Route path="/search-vehicles" element={<Layout><SearchVehicle /></Layout>} />
        <Route path="/search-result" element={<Layout><SearchResult /></Layout>} />
        <Route path="/inventory" element={<Layout><Inventory /></Layout>} />
        <Route path="/dealer-inventory" element={<Layout><DealerInventory /></Layout>} />
        <Route path="/sold-inventory" element={<Layout><SoldInventory /></Layout>} />
        <Route path="/bank-details" element={<Layout><BankDetails /></Layout>} />
        <Route path="/services/how-to-buy" element={<Layout><HowToBuy /></Layout>} />
        <Route path="/services/customer-review" element={<Layout><CustomerReview /></Layout>} />        
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/services/faq" element={<Layout><FAQ /></Layout>} />
        <Route path="/vehicle-details/:carId" element={<Layout><VehicleDetails /></Layout>} />
        
        {/* Admin Routes WITHOUT Navbar and Footer (these have their own sidebar) */}
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/add-vehicle" element={<AddVehicle />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/view-user" element={<ViewUser />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/view-sales" element={<ViewSales />} />
        <Route path="/add-new-sale" element={<AddSale />} />
        <Route path="/documents-shipping" element={<DocsShip />} />
        <Route path="/volet" element={<ViewVolet />} />
        <Route path="/create-volet" element={<CreateVolet />} />
        <Route path="/view-payments" element={<AllocatedPayments />} />
        <Route path="/create-allocate" element={<CreateAllocate />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/edit-vehicle/:id" element={<EditVehicles />} />
        <Route path="/auction" element={<Auction />} />
        <Route path="/create-group" element={<CreateGroup />} />
        <Route path="/view-groups" element={<ViewGroups />} />
        <Route path="/view-bids" element={<Bids />} />
        <Route path="/view-leads" element={<Leads />} />
        <Route path="/view-client" element={<Client />} />
        <Route path="/view-stock" element={<Stock />} />
        <Route path="/view-sale-order" element={<SaleOrder />} />
        <Route path="/view-invoice" element={<Invoice />} />
        <Route path="/view-chat-admin" element={<AdminChatViewer />} />
        <Route path="/announcements" element={<Announcements />} />
        <Route path="/announcements/new" element={<NewAnnouncements />} />
        <Route path="/client-report/transactions" element={<Transactions />} />
        <Route path="/client-report/transactions-report" element={<TransactionsReport />} />
        <Route path="/client-report/transfer-report" element={<TransferReport />} />
        <Route path="/client-report/balance-sheet" element={<BalanceSheet />} />
        <Route path="/client-report/bank-cash" element={<BankCash />} />
      </Routes>
    </Router>
  );
}

// Layout component that wraps public pages with Navbar and Footer
const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

export default App;